import { Class } from "@backend-types";
import { Box, CircularProgress, MenuItem, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../../styles/Theme";

type ClassSelectProps = {
  classId: string;
  onChange: (id: string) => void;
  options: Class[];
  disabled: boolean;
  required?: boolean;

  isLoading?: boolean;
};

function makeClassName(cls: Class): string {
  return `${cls.subject} ${cls.period_block} ${
    cls.start_date
      ? new Date(cls.start_date).toLocaleDateString("en-US", {
          timeZone: "UTC",
        })
      : ""
  }`;
}

const useStyle = makeStyles((theme) => ({
  gridItem: {
    padding: "0px !important",
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));

export function ClassSelect(props: ClassSelectProps) {
  const emptyAndDisabled = !props.classId && props.disabled;
  const classes = useStyle();
  const { isLoading = false } = props;
  return (
    <TextField
      className={classes.inputText}
      value={props.classId}
      onChange={(e) => props.onChange(e.target.value)}
      disabled={props.disabled}
      label="Class"
      required={props.required}
      InputLabelProps={{
        shrink: emptyAndDisabled || undefined,
      }}
      SelectProps={{
        displayEmpty: true,
        // Renders 'N/A' without actually setting the value
        renderValue: emptyAndDisabled ? () => "N/A" : undefined,
      }}
      fullWidth
      select>
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      )}
      {props.options.map((cls) => (
        <MenuItem key={cls.id} value={cls.id}>
          {makeClassName(cls)}
        </MenuItem>
      ))}
      {props.options.length < 1 && (
        <Typography variant="body2">No applicable classes found</Typography>
      )}
    </TextField>
  );
}
